module.exports = __webpack_public_path__ + "static/media/bloc A.024ff3e1.jpg";